import { HTTP } from "@/common/utils/http";
import { PaginationParams } from '@/common/utils/pagination-params';

export const PayNowService = {
  getAllPaymentMethods(parentId, schoolId) {
    return HTTP.get(`payments/method/${parentId}/${schoolId}/all`).then(
      ({ data }) => data
    );
  },

  createPayment(payload) {
    return HTTP.post(`payments/create`, {
      ...payload
    }).then(({ data }) => data);
  },

  confirmPayment(paymentId) {
    return HTTP.post(`payments/${paymentId}/confirm`, {}).then(
      ({ data }) => data
    );
  },

  applyCoupon(paymentId, coupon) {
    return HTTP.post(`payments/${paymentId}/coupon/apply?coupon=${coupon}`, {}).then(
      ({ data }) => data
    );
  },
  
  createCoupon(schoolId, payload) {
    return HTTP.post(`schools/coupons/${schoolId}`, payload).then(
      ({ data }) => data
    );
  },

  getAllCoupons(schoolId, params) {
    const url = PaginationParams
    .createParams(params)
    .applyToUrl(`/schools/coupons/${schoolId}/all`);
    return HTTP.get(url);
  },
  cancelClassPaymentFlow(schoolSlug, classId, childId, payNowActivityId) {
    return HTTP.delete(`schools/${schoolSlug}/classes/${classId}/enrollment/${childId}/${payNowActivityId}`).then(({ data }) => data);
  },

  cancelAftercarePaymentFlow(schoolId, aftercareId, payNowActivityId, childId) {
    return HTTP.delete(`schools/${schoolId}/aftercare/${aftercareId}/rosters/${payNowActivityId}/child/${childId}`).then(({ data }) => data);
  },

  cancelAftercareDropInPaymentFlow(schoolId, aftercareId, payNowActivityId) {
    return HTTP.delete(`schools/${schoolId}/aftercare/${aftercareId}/drop-in/${payNowActivityId}`).then(({ data }) => data);
  },
  cancelCampPaymentFlow(schoolId, campPricingId, rosterId) {
    return HTTP.delete(`schools/${schoolId}/camp-pricing/${campPricingId}/rosters/enrollment/${rosterId}`).then(({ data }) => data);
  },
    
  enrollChild(schoolSlug, classId, payload) {
    return HTTP.post(`schools/${schoolSlug}/classes/${classId}/enrollment-all`, payload).then(({ data }) => data);
  }
};



// WEBPACK FOOTER //
// ./src/common/services/pay-now.service.js